<template>
    <div>
        <v-list-item
            v-for="resultCategory in resultCategories"
            :key="resultCategory.$id"
            :href="href(resultCategory)"
            @click.prevent="navigate(resultCategory)"
        >
            <level-result :result-category="resultCategory" :live-result-category-ids="liveResultCategoryIds" />
        </v-list-item>
    </div>
</template>

<script>
import ResultCategory from '@/Models/ResultCategory.js';
import LiveIndicator from '@/Components/LiveIndicator.vue';
import Meet from '@/Models/Meet.js';
import LevelResult from '@/Components/LevelResult.vue';

export default {
    name: 'LevelResults',

    components: { LiveIndicator, LevelResult },

    inject: ['meetId'],

    props: {
        level: {
            type: String,
            required: true,
        },

        event: {
            type: String,
            required: true,
        },

        meet: {
            type: Meet,
            required: true,
        },

        liveResultCategoryIds: {
            type: Array,
            required: true,
        },
    },

    computed: {
        resultCategories() {
            return ResultCategory.query()
                .with('meet')
                .where('meet_id', this.meetId)
                .where('event', this.event)
                .where('level', this.level)
                .orderBy('gender')
                .orderBy('min_age')
                .get();
        },
    },

    methods: {
        href(resultCategory) {
            return `/result-categories/${resultCategory.id}`;
        },

        navigate(resultCategory) {
            this.$inertia.visit(this.href(resultCategory));
        },
    },
};
</script>
